import { ReactNode } from "react";
import { usePermissions } from "react-admin";
import { hasPermission, type Permission } from "./HasPermission";
import type { JSX } from "react";

interface IfPermissionProps {
  permission: Permission;
  children: ReactNode;
}

// Renders its children only when the current user's role carries `permission`
// (BR-AC-04). While permissions are still loading, nothing is rendered.
export function IfPermission({ permission, children }: IfPermissionProps) {
  let ifPermission: JSX.Element | null;
  const { isPending, permissions } = usePermissions<Permission[]>();
  if (isPending) {
    ifPermission = null;
  } else {
    if (!hasPermission(permissions, permission)) {
      ifPermission = null;
    } else {
      ifPermission = <>{children}</>;
    }
  }
  return ifPermission;
}
